import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translations: require('./locales/English.json')
    },
    es: {
      translations: require('./locales/Spanish.json')
    },
    fr: {
      translations: require('./locales/French.json')
    },
    de: {
      translations: require('./locales/German.json')
    },
    it: {
      translations: require('./locales/Italian.json')
    },
    ja: {
      translations: require('./locales/Japanese.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'es', 'fr', 'de', 'it', 'ja'];

export default i18n;